import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
  ContentfulDynamicComponentRestService,
  ContentfulRestService,
  ContentfulSeoMetadataService,
  Image,
  ComponentsModule,
  Page,
} from 'haba-contentful-components';
import { Router } from '@angular/router';
import { CustomSiteContext } from '@app/services';
import { first, map, take } from 'rxjs/operators';
import { AbstractContentfulBase } from '../AbstractContentfulBase';
import { Entry } from 'contentful';
import { environment } from '../../../environments/environment';
import { JsonLDService } from 'haba-base-components';
import { PageMeta, I18nModule } from 'haba-core';
import { User } from 'haba-core';
import { WindowRef } from 'haba-core';
import { Observable } from 'rxjs';
import { ResponsiveModalComponent } from '@app/base-components';
import { ModalService } from 'haba-storefrontlib';

import { UserService } from '../../features/user/services/user.service';
import { NgIf, AsyncPipe } from '@angular/common';
import { homepageUrl } from '@app/helpers';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  imports: [NgIf, ComponentsModule, ResponsiveModalComponent, AsyncPipe, I18nModule],
})
export class HomepageComponent extends AbstractContentfulBase implements OnInit, AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef }) public target: ViewContainerRef;
  @ViewChild('welcomeMessageModal', { static: false })
  welcomeMessageModal: ResponsiveModalComponent;

  public image: Entry<Image>;
  public imageIsVisible = false;
  public entry: Entry<Page>;

  user$: Observable<User>;

  constructor(
    protected router: Router,
    protected siteContextService: CustomSiteContext,
    protected contentfulRestService: ContentfulRestService,
    protected contentfulDynamicComponentRestService: ContentfulDynamicComponentRestService,
    protected jsonLdService: JsonLDService,
    protected winRef: WindowRef,
    protected modalService: ModalService,
    private userService: UserService,
    protected contentfulSeoMetadataService: ContentfulSeoMetadataService
  ) {
    super(router, siteContextService);
  }

  ngOnInit(): void {
    this.insertJsonLdSchema();
  }

  ngAfterViewInit(): void {
    this.contentfulRestService
      .getPageBySlug(`${homepageUrl}`, this.locale)
      .pipe(first())
      .subscribe((e: Entry<Page> | null) => {
        if (e === null) {
          this.notFound();
        } else {
          this.entry = e;
          this.image = e.fields.image;
          this.imageIsVisible = e.fields.imageIsVisible;

          const pageMeta: PageMeta = {
            title: this.contentfulSeoMetadataService.getTitle(e),
            description: this.contentfulSeoMetadataService.getDescription(e),
            image: this.contentfulSeoMetadataService.getImage(e),
            robots: this.contentfulSeoMetadataService.getRobots(e),
            canonicalUrl: this.contentfulSeoMetadataService.getCanonicalUrl(e, this.winRef),
          };

          this.contentfulSeoMetadataService.setMetadata(pageMeta);
          this.contentfulDynamicComponentRestService.renderComponents(
            this.entry.fields.content,
            this.target
          );
        }
      });
    // display popup welcome message for first time logged in user
    const sessionStorage = this.winRef.nativeWindow?.sessionStorage;
    if (sessionStorage?.getItem('last_url').includes('?token=')) {
      this.user$ = this.userService.getActiveUser().pipe(
        take(1),
        map((user) => {
          this.welcomeMessageModal.open();
          if (this.modalService.getActiveModal()) {
            const collection = document.getElementsByClassName('modal-content');
            collection[0].className += ' modal-content-bg';
          }
          return user;
        })
      );
    }
  }

  private insertJsonLdSchema(): void {
    const locale = this.locale.toLowerCase();
    const currentUrl = `${this.winRef.location.origin}/${locale}/`;
    const [, country] = locale.split('-');

    this.jsonLdService.insertSearchboxSchema(currentUrl);
    this.jsonLdService.insertLogoSchema(currentUrl, environment.jsonLdSchema, country);
  }
}
